import React from 'react';
import { BlogPostTemplate } from '../components/Blog/BlogPostTemplate';
import blogData from '../data/blog/en/why-some-people-drain-you.json';
import { BlogPostData } from '../types/blog';
export function BlogPostEmotionalDrain() {
  return <BlogPostTemplate content={blogData as BlogPostData} data-id="element-4006" />;
}